import { render, staticRenderFns } from "./FarmInfo.vue?vue&type=template&id=39ad8d44&scoped=true"
import script from "./FarmInfo.vue?vue&type=script&lang=js"
export * from "./FarmInfo.vue?vue&type=script&lang=js"
import style0 from "./FarmInfo.vue?vue&type=style&index=0&id=39ad8d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad8d44",
  null
  
)

export default component.exports